<template>
    <div class="ml20">
        <div v-for="module in config" :key="module.id">
            <p>
                <span v-if="actionIds.includes(module.id)" class="el-icon-circle-check text-color-primary mr4"></span>
                <span class="text-bold">{{module.display_name}}：</span>
                <span v-if="subDataDays[module.id]">
                    <span v-if="subDataDays[module.id]=='-1'">不限</span>
                    <span v-else-if="subDataDays[module.id]>0">最近{{subDataDays[module.id]}}天</span>
                </span>
                <span v-else-if="module.type=='1'&&!isChangedModule(module)" class="text-color-gray">未修改</span>
            </p>
            <div class="ml20" v-if="module.children&&module.children.length>0">
                <RoleConfigCard :config="module.children" :tag-action-ids-editable="tagActionIdsEditable"  :action-ids="actionIds" :sub-data-days="subDataDays" :role-action="roleAction" />
            </div>
            <div v-if="module.type=='1'">
                <div class="ml20" v-if="getFieldNames(module.fields).length>0">
                    字段权限：
                    <span class="text-bold">{{getFieldNames(module.fields)}}</span>
                </div>
                <div class="ml20" v-if="Object.keys(tagActionIdsEditable).includes(module.id)">
                    字段权限-编辑权限：
                    <span class="text-bold">{{getTagEditableFieldNames(module,tagActionIdsEditable[module.id])}}</span>
                </div>
                <div class="ml20" v-if="getFieldNames(module.dimension).length>0">
                    维度权限：
                    <span class="text-bold">{{getFieldNames(module.dimension)}}</span>
                </div>
                <div class="ml20" v-if="getFieldNames(module.func).length>0">
                    操作权限：
                    <span class="text-bold">{{getFieldNames(module.func)}}</span>
                </div>
                <div class="ml20" v-if="roleAction[module.id]">
                    数据权限：
                    <span class="text-bold" v-if="roleAction[module.id]=='2'">按照自身部门数据权限</span>
                    <span class="text-bold" v-else-if="roleAction[module.id]=='1'">全部账户&成员数据</span>
                    <span v-else>--</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RoleConfigCard",
        props:{
            config:Array,
            actionIds:Array,
            roleAction:{
                type:Object,
                default(){
                    return {};
                },
            },
            subDataDays:{
                type:[Object,Array],
                default(){
                    return {};
                },
            },
            tagActionIdsEditable:Object,
        },
        data(){
            return {

            }
        },
        methods:{
            getFieldNames(list){
                let actionIds = this.actionIds||[];
                let fieldActionIds = actionIds.filter(item=>this._findModuleById(list,item));
                return fieldActionIds.map(item=>{
                    return (this._findModuleById(list,item)||{}).display_name||'';
                }).filter(item=>!!item).join('、');
            },
            getTagEditableFieldNames(module,listStr){
                let list = listStr.split(',');
                let nameList = list.map(item=>{
                    let field = this._findModuleById(module.fields||[],item)||{};
                    return field.display_name||'';
                });
                return nameList.join('、');
            },
            isChangedModule(module){
                let actionIds = this.actionIds||[];
                if(actionIds.includes(module.id)) return true;
                let fields = actionIds.filter(item=>this._findModuleById(module.fields||[],item));
                let dimension = actionIds.filter(item=>this._findModuleById(module.dimension||[],item));
                let func = actionIds.filter(item=>this._findModuleById(module.func||[],item));

                let hasAction = !!this.roleAction[module.id];
                return [].concat(fields,dimension,func).length>0||hasAction;
            },
            _findModuleById(data, id) {
                for (let item in data) {
                    if (data[item].id == id) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findModuleById(child, id);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>
